import { createAsyncAction } from 'typesafe-actions';
import { PermissionTemplateCode, Permission, PermissionTemplate } from '@rootCommon/types/permission';

export const fetchPermissions = createAsyncAction(
  'FETCH_PERMISSIONS_REQUEST',
  'FETCH_PERMISSIONS_SUCCESS',
  'FETCH_PERMISSIONS_FAILURE',
)<PermissionTemplateCode, Permission[], Error>();

export const fetchPermissionTemplates = createAsyncAction(
  'FETCH_PERMISSION_TEMPLATES_REQUEST',
  'FETCH_PERMISSION_TEMPLATES_SUCCESS',
  'FETCH_PERMISSION_TEMPLATES_FAILURE',
)<void, PermissionTemplate[], Error>();

export default fetchPermissions;
